export default __webpack_public_path__ + "static/media/No.3-2.4f054ee3.jpg";